import {FormSectionType} from '../../../../../../blocks/FormBlock'
import defaultDeliveryData from '../organisation/deliveryData'

const deliveryData: FormSectionType = {
	...defaultDeliveryData
}

export default deliveryData
